import { ErrorInterface } from './error-interface';

export class ApiError implements ErrorInterface {
    constructor(
        public status: number,
        public type: string,
        public title: string,
        public detail: string | null = null,
        public errors: any[] = [],
    ) {
    }
}
